import styled from 'styled-components';

import {
    ButtonGroup,
} from '@zillow/constellation';

export const StyledButtonGroup = styled(ButtonGroup)`
    display: flex;
    justify-content: flex-end;
`;

export const StyledAlertText = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledCircle = styled.span`
    height: 12px;
    width: 12px;
    background-color: ${props => (props.enabled ? 'green' : '#bbb')} ;
    border-radius: 50%;
    display: inline-block;
`;
